/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 积分到期提醒-微信推送测试
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  key: string,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: string;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/member/wx-push/test/${key}`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
